module.exports = __webpack_public_path__ + "img/Step3@3x.f8109d3f.jpg";